import React from 'react';
import EventItem from "./EventItem";
import '../EventsPage.css'

const EventsList = ({ events, onEventUpdated}) => {
    return (
        <table className='table table-bordered'>
            <thead className='thead-light'>
            <tr>
                <th>Название</th>
                <th className='preview'>Превью</th>
                <th className='date'>Дата начала</th>
                <th className='date'>Дата конца</th>
                <th className='actions'>Действие</th>
            </tr>
            </thead>
            <tbody>
            {events.map(eventItem => (
                <EventItem
                    key={eventItem.id}
                    event={eventItem}
                    onEventUpdated={onEventUpdated}
                />
            ))}
            </tbody>
        </table>
    );
};

export default EventsList;